<div *ngIf="(loading$ | async) === true; else finishedLoading">
	<div class="w-full h-full flex flex-1 justify-center items-center">
		<div class="flex flex-col gap-10 justify-center items-center">
			<img
				src="/assets/images/integrations/sync-icon.png"
				class="w-20 animate-reverse-spin"
			/>
			Loading your SYNC mortgage...
		</div>
	</div>
</div>

<ng-template #finishedLoading>
	<div
		class="overflow-y-scroll duration-300"
		[ngClass]="{
			'opacity-50 pointer-events-none': (saving$ | async),
		}"
	>
		<app-closer-sync-review-mortgage-details
			[instruction]="instruction$"
			*ngIf="state === states.REVIEW"
		></app-closer-sync-review-mortgage-details>
		<app-closer-sync-sync-mortgage-fields
			[transaction]="transaction$"
			[instruction]="instruction$"
			(selectedFields)="setMergedFields($event)"
			[newMatter]="newMatter"
			*ngIf="state === states.SYNC"
			(continue)="submit()"
		></app-closer-sync-sync-mortgage-fields>
	</div>

	<div class="flex py-6 px-12 border-t border-gray-200 bg-white">
		<!-- Adding spacing to avoid chat button overlap -->
		<div class="flex flex-1 justify-end" *ngIf="state === states.REVIEW">
			<ui-button label="Next" (click)="state = states.SYNC"></ui-button>
		</div>

		<div class="flex flex-1 justify-between" *ngIf="state === states.SYNC">
			<ui-button
				label="Back"
				color="secondary"
				(click)="state = states.REVIEW"
			></ui-button>
			<ui-button
				[label]="newMatter ? 'Create' : 'Sync'"
				[loading]="saving$ | async"
				(click)="createMortgage()"
			></ui-button>
		</div>
	</div>
</ng-template>
